import { render, staticRenderFns } from "./SetupDelivery.vue?vue&type=template&id=1e6e9241&"
import script from "./SetupDelivery.vue?vue&type=script&lang=js&"
export * from "./SetupDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports